import React from 'react'

const CONSENT_OPTIONS = [
  { value: 'allowed_with_consent', label: 'Allowed with consent' },
  { value: 'always_blocked',       label: 'Always blocked' },
  { value: 'always_allowed',       label: 'Always allowed' },
];

const ConsentSelect = ({ value, onChange }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="w-full flex items-center justify-between !border !border-[#E4E4E7] !rounded-xl px-3 py-2 text-sm bg-white !text-[#17171C] hover:!border-[#17171C] focus:!border-[#17171C] focus:!shadow-none focus:!ring-0 outline-none transition cursor-pointer"
  >
    {CONSENT_OPTIONS.map((o) => (
      <option key={o.value} value={o.value}>{o.label}</option>
    ))}
  </select>
);

export default ConsentSelect
